module.exports = __webpack_public_path__ + "static/media/usa.5181ed06.png";